// 该文件定义了订单参数编辑框（弹出层）的相关事件和逻辑


var hotelQueryParams = {}


var
    
    // 在给定的日期基础上加上若干天，并格式化成 '2017-10-01' 的字符串返回
    Util = require('../util'),
    addDays = Util.addDays,
    queryString = Util.queryString,
    
    // 获取价格日历的 HTML
    monthStr = require('./modules/buildMonthHTML'),
    
    // 价格日历的相关事件
    calendarEvents = require('./modules/calendarEvents'),
    
    // 查价模块，然后填充日历
    queryPriceForCalendar = require('./modules/queryPriceForCalendar')

// 初始化点击 "预定" 按钮事件
function initOrderBtnClick (y, m, option) {
    // 引入模块样式
    require('./sass/calendarPrice.scss')
    
    $(document).delegate('#ticketCalenderPrice', 'click', function () {
        console.log("ticketCalenderPrice");
        let
            _this = $(this),
            external = _this.attr('data-citytype') === '3',
            checkin = external ? addDays(new Date, 1, '-') : addDays(new Date, 0, '-'),
            checkout = external ? addDays(new Date, 30, '-') : addDays(new Date, 29, '-'),
            ticketRangeId = queryString('ticketRangeId'),
            ticketType = queryString('ticketType'),
            priceType = queryString('priceType'),
            paymentType = queryString('paymentType'),
            itemId = queryString('itemId'),
            formulaType = queryString('formulaType')
        
        if (_this.hasClass('disabled')) return
        
        // 预定参数设置面板
        let orderParam = {
            monthStr: monthStr(y, m),
            ticketRangeId: ticketRangeId,
            ticketType: ticketType,
            priceType: priceType,
            paymentType: paymentType,
            itemId: itemId,
            formulaType: formulaType,
            startDateStr: checkin,
            endDateStr: checkout
        }
        
        var orderParamPanel = require('./templates/orderParamPanel.ejs')(orderParam)
        
        // 弹出预定参数设置面板，内含价格日历
        
        $('.calendarPrice').html(orderParamPanel)
        // 给属于主推计划内的日期添加类名
        // 		if(y && m) setClassForPush(orderParam);
        $('.hiddenOrderPrice').attr({
            'data-ticketrangeid': ticketRangeId,
            'data-ticketType': ticketType,
            'data-priceType': priceType,
            'data-paymentType': paymentType,
            'data-itemId': itemId,
            'data-formulaType': formulaType
        })
        // 查价
        queryPriceForCalendar(orderParam, null, option)
    })
    
    $(document).delegate('#beforeJumpSearchPrice', 'click', function () {

        // 首先，创建一个URLSearchParams实例
        const searchParams = new URLSearchParams(window.location.search);
        // 获取名为'param1'的参数
        // const param1 = searchParams.get('ch'); 

        let
            _this = $(this),
            // external = _this.attr('data-citytype') === '3',
            external = searchParams.get('ch') === '3',
            checkin = external ? addDays(new Date, 1, '-') : addDays(new Date, 0, '-'),
            checkout = external ? addDays(new Date, 30, '-') : addDays(new Date, 29, '-'),
            hotelId = _this.attr('data-hotelId'),
            roomId = _this.attr('data-roomId'),
            supplierId = _this.attr('data-supplierId'),
            rateType = _this.attr('data-rateType'),
            marketingStr = _this.attr('data-marketingStr');
            currency = _this.attr('data-currency');

        hotelQueryParams.hotelId = hotelId;
        hotelQueryParams.roomId = roomId;
        hotelQueryParams.supplierId = supplierId;
        hotelQueryParams.rateType = rateType;
        hotelQueryParams.marketingStr = marketingStr;
        
        if (_this.hasClass('disabled')) return
        
        // 预定参数设置面板
        let orderParam = {
            monthStr: monthStr(y, m),
            startDateStr: checkin,
            endDateStr: checkout,
            hotelId: hotelId,
            roomType: roomId,
            suppId: supplierId,
            priceType: rateType,
            currency: currency
        }
        
        var orderParamPanel = require('./templates/orderParamPanel.ejs')(orderParam)
        
        let offsetNum = _this.offset()
        
        $('.calendarPrice').html(orderParamPanel)
        $('.calendar-price-wrap').css({
            'left': '54%',
            'top': offsetNum.top + 45
        })

        $('.hiddenOrderPrice').attr({
            'data-hotelId': hotelId,
            'data-suppId': supplierId,
            'data-roomType': roomId,
            'data-priceType': rateType,
            'data-currency': currency,
        })
        
        // 查价
        queryPriceForCalendar(orderParam, null, option)
        
    })
    
    $(document).on('click', (e) => {
        e.stopPropagation()
        if ($('.jump-order-btn').length !== 0) {
            if (!$('.calendar-price-wrap').is(e.target) && $('.calendar-price-wrap').has(e.target).length == 0 && !$(e.target).hasClass('jump-order-btn')) {
                setTimeout(() => {
                    $('.calendar-price-wrap').hide()
                }, 200)
            }
        } else {
            if (!$('#ticketCalenderPrice').is(e.target) && !$('.calendar-price-wrap').is(e.target) && $('.calendar-price-wrap').has(e.target).length == 0 && !$(e.target).hasClass('month-switch-bar')) {
                setTimeout(() => {
                    $('.calendar-price-wrap').hide()
                }, 200)
            }
        }
    })
    
}

module.exports = {
    
    run: function (y, m, option) {
        
        // 初始化点击 "预定" 按钮事件
        initOrderBtnClick(y, m, option)
        
        // 初始化价格日历的相关事件
        calendarEvents(option)
    },
    hotelQueryParams: hotelQueryParams
}



// WEBPACK FOOTER //
// ./src/common/hotelCalendarPrice/calendarPrice.js